import { getEasyLayout } from '@resistdesign/voltra/app/utils';
import styled from 'styled-components';

export const {
  layout: Layout,
  areas: { Header, Main, Footer: FooterBase },
} = getEasyLayout(styled.div`
  flex: 1 0 auto;
  height: 100%;
`)`
  header, 1fr
  main, 5fr
  footer, 1fr
  \\ 1fr
`;
export const {
  layout: MainLayout,
  areas: { Left, Center, Right },
} = getEasyLayout(Main)`
  left center right, 1fr
  \\ 1fr 2fr 1fr
`;
export const Footer = styled(FooterBase)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
`;
export const Controls = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1em;
`;
export const FooterControls = styled(Controls)`
  justify-content: flex-end;
`;
